import { useDispatch,useSelector } from "react-redux";
import { setOfflineRR } from "../redux/chartoptions";
import { useState } from "react";
import IndividualComponentPopup from "./individualcomponentpopup";



function OfflineRR(){

    const [showModal,setShowModal] = useState(false);
   

    const myData = useSelector(state => state.offlineApi);

    let current_RR = myData.offline_RR[0];

        
        
        const dispatch = useDispatch();
        const checked = useSelector(state => state.chartOption.offline_RR)

        const showPopup = () =>{
            setShowModal(true);
        }
    
        const hidePopup = () =>{
            setShowModal(false);
        }
        
    

    return(
        <>
            <div className="parameter" id="offline-rr" onClick={showPopup}>                    
                <div className="label2">
                    <input type="checkbox" id="offlinerr" checked={checked} onChange={(e) => {dispatch(setOfflineRR(e.target.checked))}} />
                    <label htmlFor="offlinerr" >Offline &shy;RR</label>
                </div>
                    
                <div className="parameter_ul">
                    <ul>
                        <li type="none">Current RR : {parseFloat(current_RR).toFixed(2)} <br/> </li>
                    </ul>
                </div>
            </div>
            {showModal && <IndividualComponentPopup hider={hidePopup} bgcolor={"#ff2172a7"} />}
        </>
    );
}

export default OfflineRR;